import axios from "axios";
import { getToken } from "../../Utlis/UpdateUserState";

const REVISE_URL = `${process.env.REACT_APP_BACKEND_URL}fleet-manager/onboarding-requests/revise/`;

const getFleetManagerRevisionRequest = async (token) => {
  try {
    const res = token
      ? await axios.get(`${REVISE_URL}?token=${encodeURIComponent(token)}`)
      : await axios.get(REVISE_URL, {
          headers: { Authorization: `Bearer ${getToken()}` },
        });

    return res;
  } catch (error) {
    console.error("Fleet manager revision request fetch error:", error);
    throw error;
  }
};

const submitFleetManagerRevision = async (token, formData) => {
  try {
    const res = token
      ? await axios.patch(
          `${REVISE_URL}?token=${encodeURIComponent(token)}`,
          formData,
          { headers: { "Content-Type": "multipart/form-data" } },
        )
      : await axios.patch(REVISE_URL, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${getToken()}`,
          },
        });

    return res;
  } catch (error) {
    console.error("Fleet manager revision submit error:", error);
    throw error;
  }
};

const deleteFleetManagerRevisionDocument = async (token, documentId) => {
  try {
    const res = token
      ? await axios.delete(
          `${REVISE_URL}?document_id=${documentId}&token=${encodeURIComponent(token)}`,
        )
      : await axios.delete(`${REVISE_URL}?document_id=${documentId}`, {
          headers: { Authorization: `Bearer ${getToken()}` },
        });

    return res;
  } catch (error) {
    console.error("Fleet manager revision document delete error:", error);
    throw error;
  }
};

export {
  getFleetManagerRevisionRequest,
  submitFleetManagerRevision,
  deleteFleetManagerRevisionDocument,
};
